import React, { useState } from "react";
import { KeyRound, Loader2, Check, Circle } from "lucide-react";
import { passwordChecks, passwordProblem } from "./passwordRules.js";
import { updatePassword } from "./sync.js";

// Shown after someone opens the "reset your password" link from their email.
export default function ResetPasswordModal({ onDone, onCancel }) {
  const [pw, setPw] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const checks = passwordChecks(pw);

  async function save() {
    const problem = passwordProblem(pw);
    if (problem) { setErr(problem); return; }
    if (pw !== again) { setErr("The two passwords don't match."); return; }
    setBusy(true); setErr("");
    const { error } = await updatePassword(pw);
    setBusy(false);
    if (error) { setErr(error.message || "Couldn't update the password."); return; }
    onDone();
  }

  return (
    <div className="overlay-backdrop fixed inset-0 z-50 flex items-end lg:items-center justify-center" role="dialog" aria-modal="true" aria-label="Choose a new password">
      <div className="bg-card2 w-full max-w-md rounded-t-3xl lg:rounded-3xl p-6">
        <KeyRound size={20} className="text-brass mb-2" />
        <h3 className="v-display text-lg font-semibold">Choose a new password</h3>
        <p className="text-xs text-ivory-dim mt-1 mb-4 leading-relaxed">Your email is confirmed. Pick a strong password you don't use anywhere else.</p>
        <input value={pw} onChange={(e) => setPw(e.target.value)} type="password" autoComplete="new-password" autoFocus placeholder="New password" className="w-full rounded-lg px-3 py-2.5 text-sm mb-2" />
        <input value={again} onChange={(e) => setAgain(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} type="password" autoComplete="new-password" placeholder="Type it again" className="w-full rounded-lg px-3 py-2.5 text-sm" />
        <ul className="mt-3 space-y-1">
          {checks.map((c) => (
            <li key={c.id} className="flex items-center gap-2 text-xs" style={{ color: c.ok ? "var(--sage)" : "var(--ivory-dim)" }}>
              {c.ok ? <Check size={13} /> : <Circle size={13} />} {c.label}
            </li>
          ))}
        </ul>
        {err && <div className="text-xs mt-3" style={{ color: "var(--rust)" }}>{err}</div>}
        <button onClick={save} disabled={busy} className="w-full mt-4 flex items-center justify-center gap-2 bg-gold-grad text-ink font-semibold rounded-full py-2.5 text-sm disabled:opacity-50">{busy ? <><Loader2 size={15} className="animate-spin" /> Saving…</> : "Save new password"}</button>
        <button onClick={onCancel} className="w-full mt-2 py-2 text-xs text-ivory-dim">Not now</button>
      </div>
    </div>
  );
}
